import(/* webpackMode: "eager" */ "/opt/build/repo/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/font/local/target.css?{\"path\":\"node_modules/geist/dist/sans.js\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/geist-sans/Geist-Variable.woff2\",\"variable\":\"--font-geist-sans\",\"weight\":\"100 900\"}],\"variableName\":\"GeistSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundaryClient","DOMInspector","AnalyticsTracker"] */ "/opt/build/repo/src/utils/creatr.scripts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalErrorHandler"] */ "/opt/build/repo/src/utils/global-error-handler.tsx");
